import React from "react";
import {
  Cloud12,
  HorizontalBarChart,
  Kpi,
  LineChart23,
  PictureWall,
} from "./charts";

export const Reputation = () => (
  <svg viewBox="0 0 108 136">
    <Kpi x={8} y={8} />
    <Kpi x={40} y={8} />
    <Kpi x={72} y={8} />

    <LineChart23 x={8} y={28} />
    <HorizontalBarChart x={72} y={28} />

    <Cloud12 x={8} y={60} />
    <Cloud12 x={56} y={60} />

    <PictureWall x={8} y={92} />

    <LineChart23 x={8} y={126} />
    <HorizontalBarChart x={72} y={126} />
  </svg>
);
